import $ from "jquery";
import LZString from "lz-string";
import pako from "pako";
import { log, state } from "../settings";

const splitState = "state=";

export function encodeStateToURL(state) {
  const stateCopy = {
    m: state.model ? 1 : 0,
    rz: state.currentRotationZ,
    isRot: state.isRotated ? 1 : 0,
    h: state.height,
    l: state.length,
    w: state.width,
    ivps: state.initValuePostSize,
    bw: state.backWall ? 1 : 0,
    lw: state.leftWall ? 1 : 0,
    rw: state.rightWall ? 1 : 0,
    cr: state.colorRoof,
    cb: state.colorBody,
    e: [...state.electro.values()],
    dm: state.dayMode ? 1 : 0,
    rl: state.recessedLighting,
    tlsr: state.typeLiteShadeRoof,
    css: state.currentSubSystem,
    fah: state.fanAvatarHeight,
    faw: state.fanAvatarWidth,
    po: state.portalOption ?? 0,
    rsc: state.roofScreenColor,
    ss: [...state.subSystem.values()],
    ps: state.patternScreen,
    psr: state.patternScreenRoof,
    cs: state.colorScreen,
    pm: state.preMaterial ?? 0,
    dsm: state.defaultShadesMorph,
    ofs: state.offsetForShade,
    mpsz: state.midPointForScreenZ,
    mpsx: state.midPointForScreenX,
    xTs: state.xTalScreen,
    zTs: state.zTalScreen,
    cas: state.currentActiveSpans,
    img: state.imgForPdf ?? 0,
  };

  const jsonString = JSON.stringify(stateCopy);
  const compressed = pako.deflate(jsonString, { to: "string" });

  const base64String = arrayBufferToBase64(compressed);

  return base64String;
}

function arrayBufferToBase64(buffer) {
  const binary = Array.from(buffer)
    .map((byte) => String.fromCharCode(byte))
    .join("");
  return window.btoa(binary);
}

export function decodeURLToState(url) {
  try {
    const decompressedBase64 = atob(url);
    const decompressedArray = new Uint8Array(
      decompressedBase64.split("").map((c) => c.charCodeAt(0))
    );

    const decompressed = pako.inflate(decompressedArray, { to: "string" });

    const decodedState = JSON.parse(decompressed);

    return {
      model: decodedState.m === 1,
      currentRotationZ: decodedState.rz,
      isRotated: decodedState.isRot === 1,
      height: decodedState.h,
      length: decodedState.l,
      width: decodedState.w,
      initValuePostSize: decodedState.ivps,
      backWall: decodedState.bw === 1,
      leftWall: decodedState.lw === 1,
      rightWall: decodedState.rw === 1,
      colorRoof: decodedState.cr,
      colorBody: decodedState.cb,
      electro: new Set(decodedState.e),
      dayMode: decodedState.dm === 1,
      recessedLighting: decodedState.rl,
      typeLiteShadeRoof: decodedState.tlsr,
      currentSubSystem: decodedState.css,
      fanAvatarHeight: decodedState.fah,
      fanAvatarWidth: decodedState.faw,
      portalOption: decodedState.po === 0 ? null : decodedState.po,
      roofScreenColor: decodedState.rsc,
      subSystem: new Set(decodedState.ss),
      patternScreen: decodedState.ps,
      patternScreenRoof: decodedState.psr,
      colorScreen: decodedState.cs,
      preMaterial: decodedState.pm === 0 ? null : decodedState.pm,
      defaultShadesMorph: decodedState.dsm,
      offsetForShade: decodedState.ofs,
      midPointForScreenZ: decodedState.mpsz,
      midPointForScreenX: decodedState.mpsx,
      xTalScreen: decodedState.xTs,
      zTalScreen: decodedState.zTs,
      currentActiveSpans: decodedState.cas,
      imgForPdf: decodedState.img === 0 ? null : decodedState.img,
    };
  } catch (error) {
    console.error("Помилка при декодуванні стану:", error);
    return {};
  }
}

export function changeURL() {
  const url = encodeStateToURL(state);
  const decode = decodeURLToState(url);

  Object.assign(state, decode);

  log && console.log(state);

  const newUrl = `${window.location.origin}${window.location.pathname}?${splitState}${url}`;
  history.pushState({}, "", newUrl);

  // console.log(state);
}

export async function initStateFromUrl() {
  const urlParams = window.location.search;
  const stateParam = urlParams.split(`${splitState}`)[1];

  if (stateParam) {
    try {
      const decodedState = decodeURLToState(stateParam);

      Object.assign(state, decodedState);

      log && console.log("Стан завантажено з URL:", state);
    } catch (error) {
      log && console.error("Помилка при декодуванні стану з URL:", error);
    }
  } else {
    log && console.log("Використовуємо дефолтний стан:", state);
  }
}
